export default {
    methods:{
        select(value,name){
            this.setValue(this.steps[this.step_number],value,name)
            this.active_item = value;
            this.selected = true;
            this.$emit('isSelected')
        },
    },

    computed: {
        active_item:{
            get() {
                return this.getStepData(this.steps[this.step_number])
            },
            set(val){
                return val
            }
        }
    },
    data(){
        return {
            selected: false,
        }
    }
}